var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004f71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7aa3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965",
    transform: "translate(-627 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(627 285)",
    fill: "#fff",
    stroke: "#004f71",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(651.982 310.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4823",
    transform: "translate(-605.96 -682.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M3465.982-2181.96h0l-.017,0-.009,0-.015,0-.009,0-.015,0-.009,0-.016-.006h0a.962.962,0,0,1-.444-.333.959.959,0,0,1-.187-.589l-.277-35.854a.965.965,0,0,1,.6-.9l12.859-5.221v-9.222a.965.965,0,0,1,.965-.965h32.086a.965.965,0,0,1,.964.965v9.262l12.587,5.183a.964.964,0,0,1,.6.886l.184,35.845a.964.964,0,0,1-.071.4l0,.008,0,.012a.962.962,0,0,1-.2.3.965.965,0,0,1-.629.282H3466.22A.972.972,0,0,1,3465.982-2181.96Zm55.937-1.9-26.38-19.4-26.381,19.4Zm-54.75-.931,21.177-15.575-21.426-16.641Zm56.715-.017-.164-31.877-11.427,8.762a.967.967,0,0,1-.5.382l-9.213,7.064Zm-33.923-16.746,5.006-3.682a.963.963,0,0,1,1.142,0l4.854,3.57,9.561-7.332v-24.148h-30.157v24.14Zm22.492-8.922,10.424-7.993-10.424-4.293Zm-34.014-.027v-12.3l-10.4,4.224Zm5.206,1.428a.961.961,0,0,1-.961-.96.961.961,0,0,1,.961-.961h23.418a.961.961,0,0,1,.961.961.961.961,0,0,1-.961.96Zm0-6.228a.96.96,0,0,1-.961-.96.961.961,0,0,1,.961-.96h23.418a.961.961,0,0,1,.961.96.96.96,0,0,1-.961.96Zm0-6.228a.96.96,0,0,1-.961-.96.961.961,0,0,1,.961-.96h23.418a.961.961,0,0,1,.961.96.96.96,0,0,1-.961.96Zm5.624-6.227a.961.961,0,0,1-.961-.96.96.96,0,0,1,.961-.96h17.794a.96.96,0,0,1,.961.96.961.961,0,0,1-.961.96Z",
    transform: "translate(-2857.422 2923.428)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/check-email.9f747b81.svg";
export { ForwardRef as ReactComponent };